<template>
  <div class="map-wrapper" ref="mapChartContainer">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/leaflet.min.css"
      integrity="sha512-1xoFisiGdy9nvho8EgXuXvnpR5GAMSjFwp40gSRE3NwdUdIMIKuPa7bqoUhLD0O/5tPNhteAsE5XyyMi5reQVA=="
      crossorigin="anonymous"
    />
    <l-map
      :options="{
        preferCanvas: true,
        scrollWheelZoom: options.isUnLockMouse,
        dragging: options.isUnLockMouse,
        zoomSnap: options.zoomStep
      }"
      :style="mapStyles"
      :zoom="options.zoom"
      :min-zoom="options.minZoom"
      :max-zoom="options.maxZoom"
      :center="options.center"
      @ready="onReady"
      @update:zoom="onZoomUpdate"
      ref="lmap"
    >
      <div v-if="options.showMarker">
        <l-marker
          v-for="marker, index in markers"
          :lat-lng="marker"
          :icon="icon"
          :key="index"
        >
          <l-tooltip>
            <span v-html="markerData.data[index].name"></span>
          </l-tooltip>
        </l-marker>
      </div>
      <div v-if="options.showBubble" ref="bubbleLayer">
        <l-circle-marker
          v-for="bubble in bubbles"
          :key="bubble.name"
          :lat-lng="bubble.center"
          :radius="bubble.radius"
          :color="bubble.color"
          :fill-color="bubble.fillColor"
          :fill-opacity="bubble.fillOpacity"
        >
          <l-tooltip>
            <span v-html="bubble.tooltip"></span>
          </l-tooltip>
        </l-circle-marker>
      </div>
      <l-tile-layer :url="options.url" v-if="options.url" :tile-size="tileSize"></l-tile-layer>
      <l-tile-layer
        :url="options.tmsUrl"
        v-if="options.tmsUrl"
        :tile-size="tileSize"
        :options="options.tmsOptions"
      ></l-tile-layer>
      <l-geo-json
        v-if="geojson"
        :geojson="geojson"
        :tile-size="tileSize"
      ></l-geo-json>
      <l-geo-json
        v-for="geojsonDat, index in geojsonArr"
        :key="'geo_json_' + index"
        :geojson="geojsonDat"
        :options-style="geoJsonStyleFunction(geojsonDat)"
        :options="geoJsonoptions()"
        :tile-size="tileSize"
      ></l-geo-json>
      <l-control position="bottomleft" v-if="options.showLegend">
        <div class="legend">
          <div class="bubble-legend" ref="bubbleLegend"></div>
          <div class="color-legend" ref="colorLegend"></div>
        </div>
      </l-control>
      <l-control :position="'topleft'" v-if="options.isShowControlPanel">
        <div>
          <button v-if="!options.isUnLockMouse" @click="setUnlockMouse(true)">
            <img src="./icons/unlock.svg">
          </button>
          <button v-if="options.isUnLockMouse"  @click="setUnlockMouse(false)">
            <img src="./icons/lock.svg">
          </button>
        </div>
      </l-control>
    </l-map>
  </div>
</template>

<script>

import * as d3 from 'd3';
import _ from 'lodash';
import { LMap, LTileLayer, LGeoJson, LMarker, LTooltip, LPopup, LCircleMarker, LControl } from 'vue2-leaflet';
import { icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { escapeSpecialChars, getTooltipTemplate, ResizeObserver } from '../chart-services';
import { testGeoJson, testGeoJson2 } from './geojson';

export default {
  name: 'MapChart',
  props: {
    chartOptions: {
      type: String,
      default: '{"url":"https://geoservices.un.org/arcgis/rest/services/ClearMap_WebPlain/MapServer/tile/{z}/{y}/{x}","tmsUrl":null,"geoJsonUrl":null,"height":500,"width":null,"zoom":4,"minZoom":2,"maxZoom":6,"showMarker":false,"showBubble":true,"showLegend":true,"tmsOptions":null}'
    },
    markerData: {
      type: Object,
      default: function () {
        return {
          data: [
            // { lat: 22.87874934, long: 79.59244751, name: 'India' },
            // { lat: 33.82513149, long: 65.98371654, name: 'Afganistan' }
          ]
        };
      }
    },
    bubbleData: {
      type: String,
      default: '{"data":[]}'
      // default: '{"data":[{"country":"Papua New Guinea","lat":"-6.47264867","long":"145.1965381","indicator":"Any type of violence against women (over past 12 months)","group_access":0.07,"size":10.29,"year":"2018"},{"country":"Maldives","lat":"3.600679586","long":"73.42723242","indicator":"Any type of violence against women (over past 12 months)","group_access":0.12,"size":15.67,"year":"2017"},{"country":"Pakistan","lat":"29.94256937","long":"69.32404667","indicator":"Any type of violence against women (over past 12 months)","group_access":0.16,"size":24.14,"year":"2017"},{"country":"Philippines","lat":"11.76622348","long":"122.8632691","indicator":"Any type of violence against women (over past 12 months)","group_access":0.14,"size":9.53,"year":"2017"},{"country":"Tajikistan","lat":"38.52056929","long":"70.99960074","indicator":"Any type of violence against women (over past 12 months)","group_access":0.13,"size":15.13,"year":"2017"},{"country":"Nepal","lat":"28.24053821","long":"83.89433938","indicator":"Any type of violence against women (over past 12 months)","group_access":0.17,"size":9.59,"year":"2016"},{"country":"Armenia","lat":"40.28096895","long":"44.91053563","indicator":"Any type of violence against women (over past 12 months)","group_access":0.19,"size":13.05,"year":"2016"},{"country":"India","lat":"22.87874934","long":"79.59244751","indicator":"Any type of violence against women (over past 12 months)","group_access":0.14,"size":11.92,"year":"2016"},{"country":"Timor-Leste","lat":"-8.838046529","long":"125.8339555","indicator":"Any type of violence against women (over past 12 months)","group_access":0.12,"size":10.94,"year":"2016"},{"country":"Afghanistan","lat":"33.82513149","long":"65.98371654","indicator":"Any type of violence against women (over past 12 months)","group_access":0.07,"size":15.51,"year":"2015"},{"country":"Cambodia","lat":"12.71240061","long":"104.891231","indicator":"Any type of violence against women (over past 12 months)","group_access":0.17,"size":15.23,"year":"2014"}]}'
      // default: function () {
      //   return {
      //     data: [
      //       // { lat: 22.87874934, long: 79.59244751, name: 'India', group_access: 15, size: 100 },
      //       // { lat: 33.82513149, long: 65.98371654, name: 'Afganistan', group_access: 35, size: 80 },
      //       // { lat: 12.71240061, long: 104.891231, name: 'Cambodia', group_access: 55, size: 60 },
      //       // { lat: 21.17927543, long: 96.47187372, name: 'Myanmar', group_access: 75, size: 40 },
      //       // { lat: 46.81787689, long: 103.0366282, name: 'Mongolia', group_access: 95, size: 20 },
      //       // { lat: -2.226680254, long: 117.2406936, name: 'Indonesia', group_access: 43, size: 67 }
      //     ]
      //   };
      // }
    },
    choroplethData: {
      type: String,
      default: '{"data":[]}'
    },
    metadata: {
      type: String,
      default: '{"colorField":"group_access","radiusField":"size","nameField":"country","yearField":"year","colorFieldLabel":"D-index","radiusFieldLabel":"Size","yearFieldLabel":"Year","colorFieldUnit":"","radiusFieldUnit":"%","colorConditions":{"0-0.2":"#FFE0B2","0.21-0.4":"#FFCC80","0.41-0.6":"#FFA726","0.61-0.8":"#EF6C00","0.81-1":"#E65100"},"tooltip":{"value":"<b>\r\n [[name]] [[year]]\r\n</b>\r\n<br />\r\n[[colorFieldLabel]]: [[colorFieldValue]][[colorFieldUnit]], [[radiusFieldLabel]]: [[radiusFieldValue]][[radiusFieldUnit]]"}}'
      // ,
      // default: function () {
      //   return {
      //     colorField: 'group_access',
      //     radiusField: 'size',
      //     nameField: 'name',
      //     yearField: 'year',
      //     colorFieldLabel: 'Group Access',
      //     radiusFieldLabel: 'Size',
      //     yearFieldLabel: 'Year',
      //     colorFieldUnit: '%',
      //     radiusFieldUnit: '%',
      //     colorConditions: {
      //       '0-20': '#ffe0b2',
      //       '21-40': '#ffcc80',
      //       '41-60': '#ffa726',
      //       '61-80': '#ef6c00',
      //       '81-100': '#e65100'
      //     }
      //   };
      // }
    }
  },
  computed: {
    mapStyles () {
      return {
        height: isNaN(this.options.height) ? `${this.options.height}` : `${this.options.height}px`,
        width: this.options.width ? `${this.options.width}px` : '100%'
      };
    }
  },
  data () {
    return {
      province: undefined,
      currentProvince: undefined,
      centered: undefined,
      path: null,
      size: null,
      mapLayer: null,
      g: null,
      // center: [100, 0],
      geojson: null,
      geojsonArr: [],
      geojsonStyleArr: [],
      tileSize: 256,
      icon: icon({
        iconUrl:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAAFgUlEQVR4Aa1XA5BjWRTN2oW17d3YaZtr2962HUzbDNpjszW24mRt28p47v7zq/bXZtrp/lWnXr337j3nPCe85NcypgSFdugCpW5YoDAMRaIMqRi6aKq5E3YqDQO3qAwjVWrD8Ncq/RBpykd8oZUb/kaJutow8r1aP9II0WmLKLIsJyv1w/kqw9Ch2MYdB++12Onxee/QMwvf4/Dk/Lfp/i4nxTXtOoQ4pW5Aj7wpici1A9erdAN2OH64x8OSP9j3Ft3b7aWkTg/Fm91siTra0f9on5sQr9INejH6CUUUpavjFNq1B+Oadhxmnfa8RfEmN8VNAsQhPqF55xHkMzz3jSmChWU6f7/XZKNH+9+hBLOHYozuKQPxyMPUKkrX/K0uWnfFaJGS1QPRtZsOPtr3NsW0uyh6NNCOkU3Yz+bXbT3I8G3xE5EXLXtCXbbqwCO9zPQYPRTZ5vIDXD7U+w7rFDEoUUf7ibHIR4y6bLVPXrz8JVZEql13trxwue/uDivd3fkWRbS6/IA2bID4uk0UpF1N8qLlbBlXs4Ee7HLTfV1j54APvODnSfOWBqtKVvjgLKzF5YdEk5ewRkGlK0i33Eofffc7HT56jD7/6U+qH3Cx7SBLNntH5YIPvODnyfIXZYRVDPqgHtLs5ABHD3YzLuespb7t79FY34DjMwrVrcTuwlT55YMPvOBnRrJ4VXTdNnYug5ucHLBjEpt30701A3Ts+HEa73u6dT3FNWwflY86eMHPk+Yu+i6pzUpRrW7SNDg5JHR4KapmM5Wv2E8Tfcb1HoqqHMHU+uWDD7zg54mz5/2BSnizi9T1Dg4QQXLToGNCkb6tb1NU+QAlGr1++eADrzhn/u8Q2YZhQVlZ5+CAOtqfbhmaUCS1ezNFVm2imDbPmPng5wmz+gwh+oHDce0eUtQ6OGDIyR0uUhUsoO3vfDmmgOezH0mZN59x7MBi++WDL1g/eEiU3avlidO671bkLfwbw5XV2P8Pzo0ydy4t2/0eu33xYSOMOD8hTf4CrBtGMSoXfPLchX+J0ruSePw3LZeK0juPJbYzrhkH0io7B3k164hiGvawhOKMLkrQLyVpZg8rHFW7E2uHOL888IBPlNZ1FPzstSJM694fWr6RwpvcJK60+0HCILTBzZLFNdtAzJaohze60T8qBzyh5ZuOg5e7uwQppofEmf2++DYvmySqGBuKaicF1blQjhuHdvCIMvp8whTTfZzI7RldpwtSzL+F1+wkdZ2TBOW2gIF88PBTzD/gpeREAMEbxnJcaJHNHrpzji0gQCS6hdkEeYt9DF/2qPcEC8RM28Hwmr3sdNyht00byAut2k3gufWNtgtOEOFGUwcXWNDbdNbpgBGxEvKkOQsxivJx33iow0Vw5S6SVTrpVq11ysA2Rp7gTfPfktc6zhtXBBC+adRLshf6sG2RfHPZ5EAc4sVZ83yCN00Fk/4kggu40ZTvIEm5g24qtU4KjBrx/BTTH8ifVASAG7gKrnWxJDcU7x8X6Ecczhm3o6YicvsLXWfh3Ch1W0k8x0nXF+0fFxgt4phz8QvypiwCCFKMqXCnqXExjq10beH+UUA7+nG6mdG/Pu0f3LgFcGrl2s0kNNjpmoJ9o4B29CMO8dMT4Q5ox8uitF6fqsrJOr8qnwNbRzv6hSnG5wP+64C7h9lp30hKNtKdWjtdkbuPA19nJ7Tz3zR/ibgARbhb4AlhavcBebmTHcFl2fvYEnW0ox9xMxKBS8btJ+KiEbq9zA4RthQXDhPa0T9TEe69gWupwc6uBUphquXgf+/FrIjweHQS4/pduMe5ERUMHUd9xv8ZR98CxkS4F2n3EUrUZ10EYNw7BWm9x1GiPssi3GgiGRDKWRYZfXlON+dfNbM+GgIwYdwAAAAASUVORK5CYII=',
        // iconSize: [32, 37],
        iconAnchor: [16, 37]
      }),
      markers: null,
      bubbles: null,
      bounds: null,
      metadataObj: {},
      bubbleDataObj: {},
      choroplethDataObj: {},
      chartOptionsObj: {},
      tooltipTemplate: '<b>test</b>',
      options: {
        url: 'https://geoservices.un.org/arcgis/rest/services/ClearMap_WebPlain/MapServer/tile/{z}/{y}/{x}',
        tmsUrl: null, // 'https://tiles.thinkbluedata.com/flood100y/{z}/{x}/{y}.png'
        geoJsonUrl: null, // './Tsunami_fault_traces1.geojson'
        geoJsonName: null,
        height: 500,
        width: null,
        zoom: 4,
        minZoom: 2,
        maxZoom: 6,
        zoomStep: 1,
        radiusRatio: 4,
        showMarker: false,
        showBubble: true,
        showLegend: false,
        tmsOptions: null, // '{ "tms": false, "opacity": 1, "attribution": "", "minZoom": 2, "maxZoom": 3 }'
        center: undefined,
        isShowControlPanel: false,
        isUnLockMouse: false
      },
      resizeObserver$: null
    };
  },
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    LMarker,
    LTooltip,
    // LPopup,
    LCircleMarker,
    LControl
  },
  watch: {
    markerData: function () {
      if (this.markerData && this.markerData.data) {
        this.prepareMarkers();
        this.onReady();
      }
    },
    bubbleData: function () {
      if (this.bubbleData) {
        this.bubbleDataObj = JSON.parse(this.bubbleData);
      } else {
        this.bubbleDataObj = { data: [] };
      }
      if (this.bubbleDataObj && this.bubbleDataObj.data) {
        this.prepareBubbles();
        this.onReady();
      }
    },
    choroplethData: function () {
      if (this.choroplethData) {
        this.choroplethDataObj = JSON.parse(this.choroplethData);
      } else {
        this.choroplethDataObj = { data: [] };
      }
      if (this.choroplethDataObj && this.choroplethDataObj.data) {
        this.onReady();
      }
    },
    chartOptions: function () {
      this.chartOptionsObj = JSON.parse(this.chartOptions);
      this.initialize();
      this.onReady();
    },
    metadata: function () {
      if (this.metadata) {
        const metadata_ = escapeSpecialChars(this.metadata);
        this.metadataObj = JSON.parse(metadata_);
      }
      this.initialize();
      this.onReady();
    }
  },
  // map 1
  async created () {
    if (this.options.geoJsonUrl) {
      const response = await fetch(this.options.geoJsonUrl);
      this.geojson = await response.json();
    }
  },
  mounted () {
    this.initialize();
  },
  destroyed: function () {
    if (this.resizeObserver$ !== null) ResizeObserver.unobserve(this.resizeObserver$);
  },
  methods: {
    async initialize () {
      this.bubbleDataObj = JSON.parse(this.bubbleData);
      this.choroplethDataObj = JSON.parse(this.choroplethData);
      this.chartOptionsObj = JSON.parse(this.chartOptions);
      // console.log('chartOptionsObj', this.chartOptionsObj);
      if (this.chartOptionsObj) {
        Object.assign(this.options, this.chartOptionsObj);
        if (this.options.tmsOptions) {
          this.options.tmsOptions = JSON.parse(this.options.tmsOptions);
        }
      }

      if (this.options.geoJsonName) {
        this.prepareGeoJsonLayer();
      }

      if (this.markerData && this.markerData.data) {
        this.prepareMarkers();
      }
      if (this.bubbleDataObj && this.bubbleDataObj.data) {
        this.prepareBubbles();
      }
      if (this.resizeObserver$ === null) {
        this.resizeObserver$ = ResizeObserver.observe(this.$el, () => {
          this.$refs.lmap.mapObject.invalidateSize();
        }, { onlyWidth: true, skipFirst: true });
      }

      if (this.options.hideControlPanel) {
        const zoomEles = document.getElementsByClassName('leaflet-control-container');
        for (var i = 0; i < zoomEles.length; i++) {
          zoomEles[i].style.display = 'none';
        }
      }

      this.setUnlockMouse(this.options.isUnLockMouse);
    },
    handleCoordinate (coordinates) {
      let newCO = _.cloneDeep(coordinates);
      newCO = _.map(newCO, (d) => {
        if (d.length === 2 && typeof (d[0]) === 'number') {
          if (d[0] >= -180 && d[0] <= -155 && d[1] < 73 && d[1] > 64) {
            d[0] = d[0] + 360;
          }
        } else {
          d = this.handleCoordinate(d);
        }
        return d;
      });
      return newCO;
    },
    prepareGeoJsonLayer () {
      const tempGeo = testGeoJson2;
      tempGeo.features = _.map(tempGeo.features, (d) => {
        d.geometry.coordinates = this.handleCoordinate(d.geometry.coordinates);
        return d;
      });
      // console.log('tempGeo', _.cloneDeep(tempGeo));
      // this.geojson = tempGeo.features;

      this.geojsonArr = [];
      this.geojsonStyleArr = [];
      _.each(tempGeo.features, (f) => {
        this.geojsonArr.push(f);

        const tempStyle = {
          weight: 2,
          color: 'red',
          opacity: 0.5,
          fillColor: 'red',
          fillOpacity: 1
        };
        this.geojsonStyleArr.push(tempStyle);
      });
    },
    prepareMarkers () {
      this.markers = [];
      this.bounds = [];
      this.markerData.data.forEach((d) => {
        this.markers.push([d.lat, d.long]);
        this.bounds.push([d.lat, d.long]);
      });
    },
    prepareBubbles () {
      const metadata_ = escapeSpecialChars(this.metadata);
      this.metadataObj = JSON.parse(metadata_);
      this.bubbleDataObj = JSON.parse(this.bubbleData);
      this.bubbles = [];
      this.bounds = [];
      this.bubbleDataObj.data.forEach((d) => {
        const name = d[this.metadataObj.nameField];
        const year = d[this.metadataObj.yearField];
        const colorFieldLabel = this.metadataObj.colorFieldLabel;
        const colorFieldValue = d[this.metadataObj.colorField];
        const colorFieldUnit = this.metadataObj.colorFieldUnit;
        const radiusFieldLabel = this.metadataObj.radiusFieldLabel;
        const radiusFieldValue = d[this.metadataObj.radiusField];
        const radiusFieldUnit = this.metadataObj.radiusFieldUnit;
        let tooltipTemplate = getTooltipTemplate(this.metadataObj.tooltip.value);
        tooltipTemplate = this.formatTooltipTemplate(tooltipTemplate);
        this.bubbles.push({
          name: d[this.metadataObj.nameField],
          center: [d.lat, d.long],
          radius: d[this.metadataObj.radiusField] / this.options.radiusRatio,
          // color: this.getColor(d[this.metadataObj.colorField]),
          // fillColor: this.getColor(d[this.metadataObj.colorField]),
          color: d.color,
          fillColor: d.color,
          fillOpacity: 0.5,
          tooltip: d.tooltip ? d.tooltip : eval('`' + tooltipTemplate + '`')
        });
        this.bounds.push([d.lat, d.long]);
      });
    },
    onReady () {
      setTimeout(() => {
        this.$refs.lmap.mapObject.invalidateSize();
        if (this.bounds.length > 0 && this.options.center === undefined) {
          this.$refs.lmap.mapObject.fitBounds(this.bounds);
          return;
        }
        if (this.options.center && this.options.center.length === 2) {
          this.$refs.lmap.mapObject.panTo(this.options.center);
        }
      }, 500);
      if (this.options.showLegend && this.metadata) {
        this.renderLegend();
      }
    },
    formatTooltipTemplate (string) {
      const re = /\^\^/g;
      let result = string;
      const matches = string.match(re);
      if (matches) {
        for (const match of matches) {
          result = result.replace(match, '\\');
        }
      }

      return result;
    },
    getColor (number) {
      let color;
      for (const conditionText of Object.keys(this.metadataObj.colorConditions)) {
        const minNum = parseFloat(conditionText.split('-')[0]);
        const maxNum = parseFloat(conditionText.split('-')[1]);
        if (number >= minNum && number <= maxNum) {
          color = this.metadataObj.colorConditions[conditionText];
        }
      }
      return color;
    },
    setUnlockMouse (bool) {
      this.options.isUnLockMouse = bool;
      if (bool) {
        this.$refs.lmap.mapObject.dragging.enable();
        this.$refs.lmap.mapObject.scrollWheelZoom.enable();
      } else {
        this.$refs.lmap.mapObject.dragging.disable();
        this.$refs.lmap.mapObject.scrollWheelZoom.disable();
      }
    },
    renderLegend () {
      const metadata_ = escapeSpecialChars(this.metadata);
      this.metadataObj = this.metadata ? JSON.parse(metadata_) : {};
      if (!this.metadataObj || !this.metadataObj.colorConditions) {
        this.showLegend = false;
      } else {
        this.showLegend = true;
        // removeSVG
        d3.select(this.$refs.bubbleLegend).selectAll('*').remove();
        d3.select(this.$refs.colorLegend).selectAll('*').remove();
        // bubble legend
        const colors = Object.values(this.metadataObj.colorConditions);
        // cx, cy, r, fill, stroke
        const sizemetadata = [
          [30, 65, 20 / this.options.radiusRatio, colors[0], colors[0]],
          [90, 60, 40 / this.options.radiusRatio, colors[1], colors[1]],
          [150, 55, 60 / this.options.radiusRatio, colors[2], colors[2]],
          [210, 50, 80 / this.options.radiusRatio, colors[3], colors[3]],
          [270, 45, 100 / this.options.radiusRatio, colors[4], colors[4]]
        ];
        const bubbleSvg = d3.select(this.$refs.bubbleLegend)
          .append('svg')
          .attr('width', 300)
          .attr('height', 80)
          .append('g');
        bubbleSvg.append('g')
          .selectAll('circle')
          .data(sizemetadata)
          .enter()
          .append('circle')
          .attr('cx', function (d) { return d[0]; })
          .attr('cy', function (d) { return d[1]; })
          .attr('r', function (d) { return d[2]; })
          .attr('fill', function (d) { return d[3]; })
          .attr('fill-opacity', 0.5)
          .attr('stroke', function (d) { return d[4]; })
          .attr('stroke-width', 3);

        // color legend
        const colorConditionsKeys = Object.keys(this.metadataObj.colorConditions);
        let startScaleLabel = '';
        const endScaleLabels = [];
        for (const key of colorConditionsKeys) {
          const splitText = key.split('-');
          endScaleLabels.push(splitText[1]);
          if (!startScaleLabel) {
            startScaleLabel = splitText[0];
          }
        }
        if (!startScaleLabel) {
          startScaleLabel = '0';
        }

        // x, y, width, height, fill, endScale
        const colormetadata = [
          [0, 0, 60, 25, colors[0], endScaleLabels[0]],
          [60, 0, 60, 25, colors[1], endScaleLabels[1]],
          [120, 0, 60, 25, colors[2], endScaleLabels[2]],
          [180, 0, 60, 25, colors[3], endScaleLabels[3]],
          [240, 0, 60, 25, colors[4], endScaleLabels[4]]
        ];
        const colorSvg = d3.select(this.$refs.colorLegend)
          .append('svg')
          .attr('width', 350)
          .attr('height', 45)
          .append('g');
        colorSvg.append('g')
          .selectAll('rect')
          .data(colormetadata)
          .enter()
          .append('rect')
          .attr('x', function (d) { return d[0]; })
          .attr('y', function (d) { return d[1]; })
          .attr('width', function (d) { return d[2]; })
          .attr('height', function (d) { return d[3]; })
          .attr('fill', function (d) { return d[4]; });

        // 0 label
        colorSvg.append('g')
          .append('text')
          .attr('x', 0)
          .attr('y', 40)
          .attr('dy', '.35em')
          .attr('font-weight', 500)
          .text(startScaleLabel);

        // others labels
        colorSvg.append('g')
          .selectAll('text')
          .data(colormetadata)
          .enter()
          .append('text')
          .attr('x', function (d) { return d[0] + 45; })
          .attr('y', function (d) { return d[1] + 40; })
          .attr('dy', '.35em')
          .attr('font-weight', 500)
          .text(function (d) { return d[5]; });
      }
    },
    geoJsonStyleFunction (geojsonDat) {
      const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
      let resultColor = '#ffffff';
      const isoFeature = geojsonDat.properties && geojsonDat.properties.ISO3 ? geojsonDat.properties.ISO3 : undefined;

      if (this.choroplethDataObj && this.choroplethDataObj.data.length) {
        const foundMapData = _.find(this.choroplethDataObj.data, (d) => {
          return d.iso === isoFeature;
        });

        if (foundMapData) {
          resultColor = foundMapData.color;
        }
      }

      return () => {
        return {
          weight: 0,
          color: '#ECEFF1',
          opacity: 0.5,
          fillColor: resultColor,
          fillOpacity: 0.5
        };
      };
    },
    geoJsonoptions () {
      return {
        onEachFeature: (feature, layer) => {
          layer.bindTooltip('<span>Name: ' + feature.properties.NAME + '</span>');
        }
      };
    },
    onZoomUpdate (zoom) {
      // console.log('zoom', zoom);
    }
  }
};
</script>

<style>
.province-title {
  position: absolute;
  top: 50px;
  left: 150px;
  color: white;
}

.province-info {
  background: white;
  position: absolute;
  top: 150px;
  right: 20px;
  height: 400px;
  width: 300px;
}

.background {
  fill: #ccc;
  pointer-events: all;
}

.map-layer {
  fill: #08304b;
  stroke: orange;
  stroke-width: 1px;
}

.leaflet-bottom, .leaflet-top {
  z-index: 999 !important;
}
</style>
